import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    responseData: '',
    debuggerTime:'',
    fileRequestParams: [],
    requestBodySample:{},
    responseBodySample:{},
    fileResponseParams:[],
    code:'',
    debugTime:'',
    description:'',
    isInitDebugResult: true,//初始化调试结果，默认暂无调试结果页
    method:'',
    debugParams:{},
    bodyParams:{},
    msg:'',
    debug: false,//是否需要调试
    debugResult: {},
    listName:'',
    responseBodySample:{},
    requestBodySample2:{},
    isRealTimeData: true,
    isDisabled: false,
    callbackurlResponseBodySample:{},
    version:'',
    vType:'',
    ename:''
  },
  mutations: {
    setResponseHeader(state, val) {
      state.responseData = val;
    },
    setdebugTime(state, val){
      state.debuggerTime = val;
    },
    setFileRequestParams(state, val) {
      state.fileRequestParams = val;
    },
    setRequestBodySample(state, val) {
      state.requestBodySample = val;
    },
    setResponseBodySample(state, val) {
      state.responseBodySample = val;
    },
    setFileResponseParams(state, val) {
      state.fileResponseParams = val;
    },
    setDataCode(state, val) {
      state.code = val;
    },
    setDebugTime(state, val) {
      state.debugTime = val;
    },
    setDescription(state, val) {
      state.description = val;
    },
    reSetDebugResult(state, val) {
      state.isInitDebugResult = val;
    },
    setMethod(state, val) {
      state.method = val;
    },
    setDebugParams(state, val) {
      state.debugParams = val;
    },
    setBodyParams(state, val) {
      state.bodyParams = val;
    },
    setResultMsg(state, val) {
      state.msg = val;
    },
    setDebug(state, val) {
      state.debug = val;
    },
    setDebugResult(state, val) {
      state.debugResult = val;
    },
    setListName(state, val) {
      state.listName = val;
    },
    setRequestBodySampleTwo(state, val) {
      state.requestBodySample2 = val;
    },
    setIsRealTimeData(state, val) {
      state.isRealTimeData = val;
    },
    setIsDisabled(state,val) {
      state.isDisabled = val;
    },
    setCallbackurlResponseBodySample(state,val) {
      state.callbackurlResponseBodySample = val;
    },
    setVersion(state,val) {
      state.version = val;
    },
    setVType(state,val) {
      state.vType = val;
    },
    setEName(state,val) {
      state.ename = val;
    }
  },
  modules: {

  },
})
